import * as React from 'react'

import { Button, type Icon, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  archived: boolean
  draft: boolean
  archiveHandler: () => void
  deleteHandler: () => void
  disabled: boolean
}

const BaseButton = ({
  handler,
  text,
  icon,
  disabled,
}: {
  handler: () => void
  text: string
  icon: React.ComponentProps<typeof Icon.Medium>['icon']
  disabled: boolean
}) => {
  const [open, toggle] = useToggle(false)

  if (disabled) {
    return <Button onClick={handler} type="secondary" disabled={disabled} iconName={icon} />
  }

  return (
    <Tooltip attachment="bottom center" open={open} size="small" toggle={toggle} type="black">
      <Button onClick={handler} type="secondary" iconName={icon}></Button>
      {text}
    </Tooltip>
  )
}

const IconButton = ({ archived, archiveHandler, draft, deleteHandler, disabled }: Props) => {
  if (draft) {
    return (
      <BaseButton
        handler={deleteHandler}
        icon="delete"
        text={i18n.t('settings.custom_fields.new.labels.single_choice_options.remove')}
        disabled={false}
      />
    )
  }

  const icon = archived ? 'archive-open' : 'archive'
  let tooltipText = i18n.t('settings.custom_fields.new.labels.single_choice_options.archive')

  if (archived) {
    tooltipText = i18n.t('settings.custom_fields.new.labels.single_choice_options.unarchive')
  }

  return <BaseButton handler={archiveHandler} icon={icon} text={tooltipText} disabled={disabled} />
}

export default observer(IconButton)
